import { Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import React from 'react'
import { convertToVietnamTime } from '../../../../helper/helper'
import RewardCalcStatusCell, { RewardCalcActionsCell } from '../../../../components/RewardCalcStatusCell'

export const TableRow = (props) => {
  const { gamePeriod, analytic, result, status, totalTickets, totalRewaredTickets, totalUnRewardTickets, onCalculateRewardPress, onConfirmNumberTicket, onInputResultPress, onEditResultPress } = props;
  const hasResult = Boolean(result && result.length > 0)
  const canInputResult = !hasResult && (status === 0 || status === 1)
  const inputResultButton = canInputResult ? <Button variant="light" size="sm" className="border" onClick={() => onInputResultPress(gamePeriod)}><FontAwesomeIcon icon={faPlus} className="me-2" />Nhập kết quả</Button> : null

  const notHaveResultYet = <td><span className="text-warning me-2">Chưa có kết quả</span>{inputResultButton}</td>

  const cannotGetResult = <td><span className="text-danger me-2">Không lấy được kết quả</span>{inputResultButton}</td>

  let resultTd = notHaveResultYet

  if (result && result.length > 0 && analytic) {
    resultTd = <td>
      <div className="d-flex align-items-center gap-2 mb-2">
        <h5 className="text-primary mb-0">{result}</h5>
        <Button
          variant="light"
          size="sm"
          className="border px-2"
          onClick={() => onEditResultPress(gamePeriod, result)}
          title="Sửa kết quả"
          aria-label="Sửa kết quả"
        >
          <FontAwesomeIcon icon={faEdit} />
        </Button>
      </div>
      <span className={analytic.Even === 1 || analytic.IsEven1112 === 1 ? "text-danger" : "text-info"}> Chẵn ({analytic.TotalEven}) </span> &nbsp;
      <span className={analytic.Odd === 1 || analytic.IsOdd1112 === 1 ? "text-danger" : "text-info"}> Lẻ ({analytic.TotalOdd}) </span> &nbsp; | &nbsp;
      <span className={analytic.Upper === 1 ? "text-danger" : "text-info"}> Lớn ({analytic.TotalUpper}) </span> &nbsp;
      <span className={analytic.Lower === 1 ? "text-danger" : "text-info"}> Nhỏ ({analytic.TotalLower}) </span> &nbsp;
    </td>
  } else {
    if (status === 1) {
      resultTd = cannotGetResult
    }
  }

  return (
    <tr>
      <RewardCalcActionsCell
        gameId="keno"
        gamePeriodId={gamePeriod.id}
        status={status}
        totalTickets={totalTickets}
        totalRewaredTickets={totalRewaredTickets}
        totalUnRewardTickets={totalUnRewardTickets}
        onConfirmNumberTicket={onConfirmNumberTicket}
        onCalculateReward={hasResult ? () => onCalculateRewardPress(gamePeriod) : null}
      />
      <td>
        <b>{'#' + gamePeriod.name || ""}</b><br />
        {gamePeriod.resultDate}<br />
        <span className="text-info">{convertToVietnamTime(gamePeriod.resultTime)}</span>
      </td>
      <td>
        Tổng số vé: <b className='text-info'>{totalRewaredTickets + totalUnRewardTickets}</b><br />
        Trúng thưởng: <b className='text-success'>{totalRewaredTickets}</b><br />
        Không trúng thưởng: <b className='text-danger'>{totalUnRewardTickets}</b><br />
      </td>
      {resultTd}
      <RewardCalcStatusCell
        status={status}
        totalTickets={totalTickets}
        totalRewaredTickets={totalRewaredTickets}
        totalUnRewardTickets={totalUnRewardTickets}
      />
    </tr>
  );
};
